// *** Functions for Custom video hero section ***

  // icons for buttons
  const soundOnSVG = `<svg id="sprite-controls-volume-on-filled" xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' fill='currentColor' width='16px' height='16px' viewBox='0 0 80 80' xml:space='preserve'><path fill-rule="evenodd" d="M63.83 2c20.893 20.893 20.893 54.767 0 75.66l-4.95-4.95c18.16-18.159 18.16-47.6 0-65.76L63.83 2zM53.224 12.607c15.035 15.035 15.035 39.412 0 54.447l-4.95-4.95c12.301-12.301 12.301-32.246 0-44.548l4.95-4.95zM29.695 14v52L11 50H0V30h11l18.695-16zm12.922 9.213c9.177 9.178 9.177 24.057 0 33.234l-4.95-4.95c6.444-6.443 6.444-16.89 0-23.334l4.95-4.95z"/></svg>`;
  const soundOffSVG = `<svg id="sprite-controls-volume-off-filled" xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' fill='currentColor' width='16px' height='16px' viewBox='0 0 80 80' xml:space='preserve'><path fill-rule="evenodd" d="M29.695 14v52L11 50H0V30h11l18.695-16zm43.622 5l5.79 5.067L65.165 40l13.942 15.933L73.317 61 60.053 45.842 46.791 61 41 55.933 54.941 40 41 24.067 46.79 19l13.263 15.158L73.317 19z"/></svg>`;
  const playSVG = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="currentColor" width="12px" height="12px" viewBox="0 0 80 80" xml:space="preserve"><path d="M80 40.7L10 81.4V0z"/></svg>`;
  const pauseSVG = `<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' fill='currentColor' width='12px' height='12px' viewBox='0 0 80 80' xml:space='preserve'><path d="M10 0h20v80H10zm40 0h20v80H50z"/></svg>`;

  // Function to switch video source based on window width
  function switchVideoSource(video, videoContainer, mobileVideoPath, desktopVideoPath ) {
    const isMobileWidth = window.matchMedia('(max-width: 60em)').matches;

    // Switch the video source
    const currentPath = isMobileWidth ? mobileVideoPath : desktopVideoPath;
    if (video.src !== currentPath) {
        changeVideoSource(video, currentPath);
    }

    // Manage the classes on the video container
    if (isMobileWidth) {
      if (!videoContainer.classList.contains('mobile')) {
        console.log('~ mobile');
        videoContainer.classList.add('mobile');
      }
      if (videoContainer.classList.contains('desktop')) {
        videoContainer.classList.remove('desktop');
      }
    } else {
      if (!videoContainer.classList.contains('desktop')) {
        console.log('~ desktop');
        videoContainer.classList.add('desktop');
      }
      if (videoContainer.classList.contains('mobile')) {
        videoContainer.classList.remove('mobile');
      }
    }
  }

  // Change video source of the video element
  function changeVideoSource(video, newPath) {
      video.pause();
      video.src = newPath;
      video.load();
      video.play();
  }

  //Move the element to the top of the body
  function moveToTop(elementToMove, video) {
    
    if(elementToMove) {
      // Store the original parent
      // window.originalParent = elementToMove.parentNode;

      // Move the element to the top of the body
      document.documentElement.insertBefore(elementToMove, document.documentElement.firstChild);
      document.body.style.display = 'none';
    }
    
    if (video) {
      video.controls = true;
      playFromBeginning(video);
      
      // openFullscreen(video);
      // video.setAttribute('playsinline', '');
      // video.style.objectFit = 'cover';
      // video.setAttribute('controls', '');
      // video.style.scale = '1';
    }
  }

  // Move the element back to its original container
  function moveToOriginal(videoContainerParent, video, soundToggleButton, playPauseButton) {
    if (video) {
      video.muted = true;
      video.controls = false;
      soundToggleButton.innerHTML = video.muted ? soundOffSVG : soundOnSVG;
      playPauseButton.innerHTML = video.paused ? playSVG : pauseSVG;
    }

    if(videoContainerParent) {
        document.body.style.display = 'block';
        videoContainerParent.appendChild(document.querySelector('.video-hero__inner'));
        
        if (videoContainerParent.classList.contains('scroll-to-from-fullscreen')) {
          // Scroll to videoContainerParent
          videoContainerParent.scrollIntoView({ behavior: 'smooth' });
        }
    }
  }

  // Play the video from beginning
  function playFromBeginning(video) {
    video.currentTime = 0;  // Rewind the video to the start
    video.muted = false;
    video.volume = .5;       // (range is 0 to 1)
    video.play();
  }

  //Open the video in fullscreen
  function openFullscreen(video) {
    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.mozRequestFullScreen) { /* Firefox */
      video.mozRequestFullScreen();
    } else if (video.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) { /* IE/Edge */
      video.msRequestFullscreen();
    }
  }

// *** Functions for Custom video hero section ***